"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertDetailComponent = void 0;
var React = require("react");
var Localize_1 = require("../../gen-src/Localize");
var styles = require("../styles/DataAlerts");
var colors = require("../util/colors");
var AlertDataLeakageTextComponent_1 = require("./AlertDataLeakageTextComponent");
var BarChartComponent_1 = require("./BarChartComponent");
var IMPACTED_COLOR = colors.orange;
var OTHER_COLOR = colors.tableauGray09;
var REFERENCE_LINE_COLOR = colors.brandOrange;
var COLLINEAR_FIELD_REFERENCE_VALUE = 0.5;
var DISPARATE_IMPACT_REFERENCE_VALUE = 0.8;
var ALERT_CHART_WIDTH = 480;
var REFERENCE_GROUP_VALUE = 100;
var AlertDetailComponent = function (props) {
    var _a, _b;
    var barColor = (_a = props.color) !== null && _a !== void 0 ? _a : colors.background01;
    var referenceColor = (_b = props.color) !== null && _b !== void 0 ? _b : colors.background01;
    var renderThresholdFooter = function (threshold) {
        return (React.createElement("div", { className: styles.alertCollinearFootNote },
            React.createElement("span", { style: { color: REFERENCE_LINE_COLOR } }, Localize_1.Messages.ThresholdFootNote({ threshold: threshold }))));
    };
    var renderRecommendedBucketsAlert = function (relatedData) {
        if (!(relatedData === null || relatedData === void 0 ? void 0 : relatedData.recommendedBuckets)) {
            return null;
        }
        return (React.createElement("ul", { className: styles.alertSuggestedBucketsUnOrderList }, relatedData.recommendedBuckets.map(function (data, index) { return (React.createElement("li", { key: index, className: styles.recommendedBucketStyle }, data)); })));
    };
    var formatThreshold = function (threshold) { return threshold * 100 + "%"; };
    var renderCollinearFieldsAlert = function (relatedData) {
        var _a;
        if (!(relatedData === null || relatedData === void 0 ? void 0 : relatedData.collinearFields) || !((_a = relatedData === null || relatedData === void 0 ? void 0 : relatedData.referenceField) === null || _a === void 0 ? void 0 : _a.label)) {
            return null;
        }
        var yAxisLabel = Localize_1.Messages.ChartScoreLabel({ fieldLabel: relatedData.referenceField.label });
        var rows = relatedData.collinearFields
            .map(function (data) {
            return {
                name: data.fieldLabel,
                // Convert to percentage
                count: Math.round(data.score * 100),
                color: barColor,
            };
        })
            .sort(function (data1, data2) { return data2.count - data1.count; });
        if (!rows || !rows.length) {
            return null;
        }
        rows.unshift({ name: relatedData.referenceField.label, count: REFERENCE_GROUP_VALUE, color: barColor });
        return (React.createElement(React.Fragment, null,
            renderThresholdFooter(formatThreshold(COLLINEAR_FIELD_REFERENCE_VALUE)),
            React.createElement(BarChartComponent_1.BarChartComponent, { data: rows, yAxisLabel: yAxisLabel, referenceLine: {
                    color: REFERENCE_LINE_COLOR,
                    value: COLLINEAR_FIELD_REFERENCE_VALUE,
                }, width: ALERT_CHART_WIDTH })));
    };
    var renderDataLeakageAlert = function (relatedData) {
        if (!relatedData || !relatedData.outcome || !relatedData.referenceField || !relatedData.values) {
            return null;
        }
        var _a = relatedData.outcome, outcomeLabel = _a.label, outcomeSuccessValue = _a.successValue;
        var barChartData = relatedData.values.map(function (value) {
            return {
                name: value.label,
                count: value.percentSuccess,
                color: barColor,
            };
        });
        var yAxisLabel = outcomeLabel + ": " + outcomeSuccessValue + " (%)";
        barChartData.sort(function (a, b) {
            var percentDiff = b.count - a.count;
            return percentDiff === 0 ? a.name.toLowerCase().localeCompare(b.name.toLowerCase()) : percentDiff;
        });
        return (React.createElement("div", null,
            React.createElement(AlertDataLeakageTextComponent_1.AlertDataLeakageTextComponent, { relatedData: relatedData }),
            React.createElement(BarChartComponent_1.BarChartComponent, { data: barChartData, yAxisLabel: yAxisLabel, width: ALERT_CHART_WIDTH })));
    };
    var renderDisparateImpactAlert = function (fieldName, relatedData) {
        var rows = relatedData.adverseImpactRatios.map(function (group) {
            return {
                name: group.valueLabel,
                count: group.referenceGroup ? REFERENCE_GROUP_VALUE : group.adverseImpactRatio,
                color: group.referenceGroup ? referenceColor : group.disparateImpacted ? IMPACTED_COLOR : OTHER_COLOR,
            };
        });
        var yAxisLabel = Localize_1.Messages.BiasAdverseRatio();
        var legend = [
            {
                text: Localize_1.Messages.BiasReference(),
                color: referenceColor,
            },
            {
                text: Localize_1.Messages.BiasImpacted(),
                color: IMPACTED_COLOR,
            },
            {
                text: Localize_1.Messages.BiasOther({ fieldLabel: fieldName }),
                color: OTHER_COLOR,
            },
        ];
        var title = React.createElement("span", { className: styles.alertDisparateImpactTitle }, fieldName);
        return (React.createElement(React.Fragment, null,
            renderThresholdFooter(formatThreshold(DISPARATE_IMPACT_REFERENCE_VALUE)),
            React.createElement(BarChartComponent_1.BarChartComponent, { data: rows, legend: legend, title: title, yAxisLabel: yAxisLabel, width: ALERT_CHART_WIDTH, referenceLine: { color: REFERENCE_LINE_COLOR, value: DISPARATE_IMPACT_REFERENCE_VALUE } })));
    };
    var renderAlertDetail = function (alert) {
        if (props.hidden) {
            return null;
        }
        switch (alert.type) {
            case 'RecommendedBuckets':
                return renderRecommendedBucketsAlert(alert.relatedData);
            case 'CollinearFields':
            case 'CorrelateWithProtectedFields':
                return renderCollinearFieldsAlert(alert.relatedData);
            case 'DataLeakage':
                return renderDataLeakageAlert(alert.relatedData);
            case 'DisparateImpact':
                return renderDisparateImpactAlert(alert.key, alert.relatedData);
            default:
                return null;
        }
    };
    return renderAlertDetail(props.alert);
};
exports.AlertDetailComponent = AlertDetailComponent;
//# sourceMappingURL=AlertDetailComponent.js.map